import React, {useEffect} from 'react';
import img from "../../static/img";
import EditTable from "../../components/editTable";
import MoyenContact from "../../forms/moyenContact";
import screens from "../../screens";
import {Get, Post} from "../../components/request";
import loadParameters from "../../components/loadParameters";
import {Alert, Button, Col, Container, Form, Row} from "react-bootstrap";
import Student from "../../components/student";
import {toast} from "react-toastify";
import {withRouter} from "react-router-dom";
import {getRoute} from "../../breadcrumb/utils";
import Security from "../../components/security";

function Proclamation({history}) {
    const [validated, setValidated] = React.useState(false);
    const [contacts, setContacts] = React.useState([]);
    const [parameters] = React.useState({state: {parameters: []}});

    const handleSubmit = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const form = e.currentTarget;
        let validity = form.checkValidity();

        if (contacts < 1 || !contacts.some(s => s.TypeMoyenContact === "Email")) {
            toast.warn("Veuillez renseigner au minimum un moyen de contact de type \"Email\".");
            validity = false;
        }

        if (validity === true) {
            const data = new FormData(form);
            const result = await Post(`/v1/extranet/student/${screens.Proclamation}`, Object.fromEntries(data), "Sauvegarde en cours..", {render: "Sauvegarde réussie !"}, {render: "Erreur lors de la sauvegarde"});
            
            if (result) {
                Security.denyPage(screens.Proclamation);
                history.push(getRoute(screens.Dashboard));
            }
        } else {
            setValidated(validity);
            form.reportValidity();
        }
    }
    
    const fetchParameters = async () => {
        await loadParameters(parameters, 'TypeMoyenContactID');

        let {body} = await Get(`/v1/extranet/student/${screens.Reinscription}02`);
        setContacts(body);
    }

    useEffect(() => {
        fetchParameters();
    }, []);

    return (
        <section>
            <div style={{display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column"}}>
                <img src={img.ProclamationBanner} alt="Proclamation" style={{width: '100%'}}/>
                <h1 style={{padding: "2rem 0"}}>Cérémonie de proclamation</h1>
                <Container>
                    <Student simplify={true}/>
                    <Row style={{margin: "2rem -14px"}}>
                        <Col>
                            <p>Veuillez le cas échéant actualiser vos moyens de contact s'il vous plaît.</p>
                            <EditTable columns={{"Type": "TypeMoyenContact", "Contact": "MoyenContactValeur"}}
                                       parameters={parameters.state.parameters}
                                       table={contacts}
                                       form={MoyenContact}
                                       screenID={`${screens.Reinscription}02`}
                                       reload={fetchParameters.bind(this)}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Alert variant={"warning"}>
                                Pour des raison d'organisation, <b>2 invités par étudiant maximum</b> sont admis. Les
                                entrées seront controlées.<br/>
                                For organizational reasons, <b>a maximum of 2 guests per student</b> are allowed.
                                Entrances will be controlled.
                            </Alert>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                <Form.Group>
                                    <Form.Label>Nombre d'accompagnants / Number of accompanying persons</Form.Label>
                                    <br/>
                                    <Form.Check required inline label={"0"} value={"0"} name={"guests"} type={"radio"}
                                                className={"ml-4"}/>
                                    <Form.Check required inline label={"1"} value={"1"} name={"guests"} type={"radio"}
                                                className={"ml-4"}/>
                                    <Form.Check required inline label={"2"} value={"2"} name={"guests"} type={"radio"}
                                                className={"ml-4"}/>
                                    <Form.Check required inline label={""} value={""} name={"guests"} type={"radio"}
                                                className={"ml-4"}>
                                        <Form.Control.Feedback type="invalid">
                                            Select one option!
                                        </Form.Control.Feedback>
                                    </Form.Check>
                                    
                                </Form.Group>
                                <Button type="submit"
                                        variant="success"
                                        size={"lg"}
                                        className={"mr-3"}
                                        block>
                                    Sauvegarder
                                </Button>
                            </Form>
                        </Col>
                    </Row>
                </Container>


            </div>
        </section>
    );
}


export default withRouter(Proclamation);